<template>
    <div class="chart-container">
      <canvas id="pieChart"></canvas>
    </div>
  </template>
 <script>
 export default {
   name: "PieChart",
   props: {
     labels: {
       type: Array,
       required: true, // Example: ["Red", "Blue", "Yellow"]
     },
     data: {
       type: Array,
       required: true, // Example: [12, 19, 3]
     },
   },
   mounted() {
     this.renderPieChart();
   },
   methods: {
     renderPieChart() {
       const ctx = document.getElementById("pieChart").getContext("2d");
       new window.Chart(ctx, {
         type: "pie", // Define the type as 'pie'
         data: {
           labels: this.labels, // Labels on the pie chart
           datasets: [
             {
               data: this.data, // The data values
               backgroundColor: [
                 "rgba(75, 192, 192, 0.6)",
                 "rgba(54, 162, 235, 0.6)",
                 "rgba(255, 206, 86, 0.6)",
                 "rgba(153, 102, 255, 0.6)",
                 "rgba(255, 159, 64, 0.6)",
               ], // Colors for the pie sections
               borderColor: [
                 "rgba(75, 192, 192, 1)",
                 "rgba(54, 162, 235, 1)",
                 "rgba(255, 206, 86, 1)",
                 "rgba(153, 102, 255, 1)",
                 "rgba(255, 159, 64, 1)",
               ], // Border colors for each section
               borderWidth: 1,
             },
           ],
         },
         options: {
           responsive: true,
           plugins: {
             legend: {
               display: false, // Disable the legend
             },
             tooltip: {
               callbacks: {
                 label: function (tooltipItem) {
                   return tooltipItem.label + ": " + tooltipItem.raw; // Display data value on tooltip
                 },
               },
             },
           },
         },
       });
     },
   },
 };
 </script>
 
  <style scoped>
  .chart-container {
    width: 100vw; /* Adjust container width */
    height: 100vh; /* Full viewport height */
  }
  
  canvas {
    width: 100%; /* Let the canvas take full width of the container */
    height: 100%; /* Let the canvas take full height of the container */
  }
  </style>
  